import { CashToClose } from "@eave/shared/types/api/disclosures";
import APIClient from "web_modules/APIClient";

interface CashToCloseResponse {
  cash_to_close: CashToClose;
  meta: {
    error_detail: string;
  };
}

export const fetchCashToCloseSummary = (appId: number): Promise<CashToCloseResponse> => {
  return APIClient.get(`/uw/${appId}/cash_to_close`) as Promise<CashToCloseResponse>;
};
